module.exports = __webpack_public_path__ + "static/media/29ADMSPC35.03af44f2.jpg";